// A hero image to default to if the newly released movie doesn't look good with my color scheme
export const heroPoster = {
    adult: false,
    backdrop_path: "/kcga7xuiQVqM9WHfWnAbidxU7hd.jpg",
    genre_ids: [80, 28, 53],
    id: 458156,
    original_language: "en",
    original_title: "John Wick: Chapter 3 – Parabellum",
    overview: "Super-assassin John Wick returns with a $14 million price tag on his head and an army of bounty-hunting killers on his trail. After killing a member of the shadowy international assassin’s guild, the High Table, John Wick is excommunicado, but the world’s most ruthless hit men and women await his every turn.",
    popularity: 473.246,
    poster_path: "/ziEuG1essDuWuC5lpWUaw1uXY2O.jpg",
    release_date: "2019-05-15",
    title: "John Wick: Chapter 3 – Parabellum",
    video: false,
    vote_average: 7.4,
    vote_count: 507
};
